import qs from "query-string";
import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { changeCaseOn } from "../ducks/utils";

const useQueryParams = () => {
  const history = useHistory();
  const { search, pathname } = useLocation();
  const queryParams = useMemo(
    () => changeCaseOn("camelCase", qs.parse(search, { arrayFormat: "bracket" })),
    [search]
  );
  const mergeParams = params =>
    history.push(
      qs.stringifyUrl(
        {
          url: pathname,
          query: { ...queryParams, ...params }
        },
        { arrayFormat: "bracket" }
      )
    );
  return [queryParams, mergeParams];
};

export default useQueryParams;
